import React from 'react';
import Catalog from '@/finsight/ui/components/static/Catalog';
import getServerSideSponsorsCatalog
  from '@/finsight/application/Catalog/Sponsors/serverSide/getServerSideSponsorsCatalog';
import { CatalogSponsorsProvider } from '@/finsight/application/Catalog/Sponsors/SponsorsCatalogContext';
import ICatalogCollection from '@/finsight/application/Catalog/common';
import withFinsightGlobalProps from '@/finsight/application/withFinsightGlobalProps';

export const getServerSideProps = withFinsightGlobalProps(async (context) => {
  const serverSponsorsCatalog: ICatalogCollection = await getServerSideSponsorsCatalog(context);
  return {
    props: {
      serverSponsorsCatalog,
    },
  };
});

const ListOfGlobalFixedIncomeCorporateSponsors = ({ serverSponsorsCatalog }: ICatalogCollection) => (
  <CatalogSponsorsProvider sponsors={ serverSponsorsCatalog }>
    <Catalog />
  </CatalogSponsorsProvider>
  );

export default ListOfGlobalFixedIncomeCorporateSponsors;
